"use client"

import React from "react";
import Link from "next/link";
import Image from "next/image";

import Logo from "@/assets/images/logo/logo_white.svg";

import styles from "@/styles/NotFound.module.scss"

const NotFound = () => (
  <div className="main-page-wrapper roboto-bold dark-style lg-container p0">
    <div className="error-page row">
      <div
        className="img-holder h-100 order-lg-last"
      >
        <div
          className={styles.notFoundImage}
        />
      </div>
      <div className="text-wrapper m-auto">
        <Link
          className={"logo"}
          href={"https://www.downfor.life/"}
          title={`Link to Downfor`}
        >
          <Image
            src={Logo}
            alt="The Downfor Logo"
            title={"Downfor Logo"}
            width={30}
            height={30}
            priority={true}
          />
        </Link>
        <h1 className="roboto-bold">
          Sorry, <br />
          The Page Can`t <br />
          be Found.
        </h1>
        <Link
          href={"https://www.downfor.life/"}
          className={`downfor-button w-60 mt-20 mb-20 p-1 ${styles.downforButton}`}
          title={`Link to home page`}
        >
          <span>Back to Home</span>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
